import assignPlanDialogCtrl from "./assignPlanDialog/assignPlanDialog.controller.js";
import assignPlanDialog from "./assignPlanDialog/assignPlanDialog.html";
import isEmpty from "lodash/fp/isEmpty";

class Controller {
  constructor($injector, $mdDialog) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.Events = $injector.get("Events");
    this.Messages = $injector.get("Messages");
    this.Messages = $injector.get("Messages");
    this.CaptainPlan = $injector.get("CaptainPlan");
  }

  $onInit() {
    this.assignPlan = () => {
      const assign = this.$mdDialog.show({
        controller: assignPlanDialogCtrl,
        controllerAs: "$ctrl",
        template: assignPlanDialog,
        autoWrap: false,
        bindToController: true,
        escapeToClose: false,
        clickOutsideToClose: false,
        locals: {
          captainName: this.captain.name.value,
          forced: Boolean(this.showDialog),
          captainCity: this.captain.city,
        },
      });

      assign.then(
        (obj) => {
          obj.captain = this.captain._id.value;

          this.Events.emit(this.addEvent, obj);
        },
        () => {}
      );
    };

    if (this.showDialog) this.assignPlan();

    this.Events.on(this.showDialogInvokerEvent, this.assignPlan.bind(this));
  }

  checkEmptyGarage(coordinates) {
    return isEmpty(coordinates);
  }

  $onDestroy() {
    this.$mdDialog.cancel();
    this.Events.off(this.showDialogInvokerEvent, this.assignPlan);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/captainPlan/captainPlan.controller.js